import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Form } from '@angular/forms'
import { FolderService } from '../folder.service'
import { LoaderService } from '../../ui-shared/loader/loader.service'

@Component({
	selector: 'app-folder-upload',
	templateUrl: './folder-upload.component.html',
	styleUrls: ['./folder-upload.component.scss']
})

export class FolderUploadComponent implements OnInit {

	isChrome

	constructor(
		public folder: FolderService,
		public router: Router,
		public loader: LoaderService,
	) {}

	ngOnInit() {
		this.isChrome = navigator.userAgent.indexOf('Chrome') != -1
	}

	onUpload(data) {
		let _update = {
			'files': data,
			'versions': this.folder.current.versions || {},
			'messages': this.folder.current.messages || {},
		}

		// console.log(_update.messages)

		for (let i in data) {
			_update.versions[i] = _update.versions[i] || []
			_update.versions[i].push(data[i])

			let updateMessageId = this.folder.createPushId()
			_update.messages[i] = _update.messages[i] || {}
			_update.messages[i][updateMessageId] = {
				id: updateMessageId,
				type: 'update',
				path: data[i].path,
				date: data[i].updated,
				user: {
					username: data[i].uploaded_by.username || data[i].uploaded_by.name,
					uid: data[i].uploaded_by.uid || data[i].uploaded_by.id,
				}
			}
		}

		this.folder.update(this.folder.current.id + '/versions', _update.versions).then(() => {
			this.folder.update(this.folder.current.id + '/messages', _update.messages).then(() => {
				this.folder.update(this.folder.current.id + '/files', _update.files).then(() => {
					this.router.navigate(['/folder/', this.folder.current.id])
					this.loader.stop()
				})
			})
		})
	}
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-upload/folder-upload.component.ts